import React from "react"
import { useStaticQuery, graphql, withPrefix } from "gatsby"
import Img from "gatsby-image"
import { useIntl, FormattedMessage } from "react-intl"
import { langId } from "../languages"
import { socialConfig } from "../config"
import { useLinkLanguage } from "../hooks"
import classnames from "classnames"
import { ExternalLink } from "../components"

const Qrcode = ({ qrcodeFluidImg }) => {
  const intl = useIntl()
  return (
    <div className="footer-qrcode">
      <div className="footer-qrcode__img">
        <Img
          fluid={qrcodeFluidImg}
          alt={intl.formatMessage({ id: langId.LINK_REIT_WECHAT_QR_CODE })}
          title={intl.formatMessage({ id: langId.LINK_REIT_WECHAT_QR_CODE })}
        ></Img>
      </div>
      <div className="footer-qrcode__help">
        <FormattedMessage id={langId.SCAN_IN_WECHAT}></FormattedMessage>
      </div>
      <div className="footer-qrcode__arrow"></div>
    </div>
  )
}

const SocialIcon = ({ socialmedia, qrcodeFluidImg }) => {
  const intl = useIntl()
  const linkLang = useLinkLanguage()
  const wechatUrl = socialmedia.url.replace("/sc/", `/${linkLang}/`)
  return (
    <a
      href={socialmedia.key === "wechat" ? wechatUrl : socialmedia.url}
      target="_blank"
      rel="noopener"
      title={intl.formatMessage({ id: socialmedia.name })}
      className={classnames({
        footer__social__wechat: socialmedia.key === "wechat",
      })}
    >
      <img
        src={withPrefix(socialmedia.img)}
        title={intl.formatMessage({ id: socialmedia.name })}
        alt={intl.formatMessage({ id: socialmedia.name })}
      ></img>
      {socialmedia.key === "wechat" && (
        <div className="footer__social__qrcode-container">
          <Qrcode qrcodeFluidImg={qrcodeFluidImg}></Qrcode>
        </div>
      )}
    </a>
  )
}

const Footer = () => {
  const Images = useStaticQuery(graphql`
    query {
      linkreitLogoPink: file(
        relativePath: { eq: "images/linkreit-logo-white-pink.png" }
      ) {
        ...fragmentsFluidImage
      }

      linkreitDigitalPresenceWechat: file(
        relativePath: {
          eq: "images/link-reit-channel-823-q2-2020-expands-digital-presence-wechat.png"
        }
      ) {
        ...fragmentsFluidImage
      }
    }
  `)
  const intl = useIntl()
  const linkLanguage = useLinkLanguage()
  return (
    <footer className="footer">
      <div>
        <a
          href={`https://www.linkreit.com/${linkLanguage}/home/`}
          target="_blank"
          rel="noopener"
          className="footer__link-logo"
        >
          <Img
            fluid={Images.linkreitLogoPink.childImageSharp.fluid}
            alt={intl.formatMessage({ id: langId.LINK_REIT })}
            title={intl.formatMessage({ id: langId.LINK_REIT })}
          ></Img>
        </a>
        <ExternalLink
          href={`https://www.linkreit.com/${linkLanguage}/copyrightAndDisclaimer/`}
          title={intl.formatMessage({ id: langId.COPYRIGHT_DISCLAIMER })}
          className="footer__disclaimer"
        >
          <FormattedMessage id={langId.COPYRIGHT_DISCLAIMER}></FormattedMessage>
        </ExternalLink>
      </div>

      <div className="footer-spliter"></div>

      <div>
        <div className="footer__all-right">
          <FormattedMessage id={langId.ALL_RIGHT_RESERVED}></FormattedMessage>
        </div>
        <div className="footer__social">
          {socialConfig.map(social => (
            <SocialIcon
              key={social.key}
              socialmedia={social}
              qrcodeFluidImg={
                Images.linkreitDigitalPresenceWechat.childImageSharp.fluid
              }
            ></SocialIcon>
          ))}
        </div>
      </div>
    </footer>
  )
}

export default Footer
